import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { ProjectChangeControlActions } from './project-change-control.actions';
import { ProjectChangeControlService } from '@/core/services/project-change-control.service';

@Injectable()
export class ProjectChangeControlEffects {
  private actions$ = inject(Actions);
  private projectChangeControlService = inject(ProjectChangeControlService);

  loadRequests$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectChangeControlActions.loadRequests),
      switchMap(({ projectId }) =>
        this.projectChangeControlService.getByProjectId(projectId).pipe(
          map((requests) => ProjectChangeControlActions.loadRequestsSuccess({ requests })),
          catchError((error) =>
            of(ProjectChangeControlActions.loadRequestsFail({
              error: error?.message ?? 'Error al cargar los controles de cambio',
            }))
          )
        )
      )
    )
  );

  submitRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ProjectChangeControlActions.submitRequest),
      switchMap(({ request, projectId }) =>
        this.projectChangeControlService.createByProjectId(projectId, request).pipe(
          map((saved) => ProjectChangeControlActions.submitRequestSuccess({ request: saved })),
          catchError((error) =>
            of(ProjectChangeControlActions.submitRequestFail({
              error: error?.message ?? 'Error al crear el control de cambio',
            }))
          )
        )
      )
    )
  );
}
